import React, { useState, useEffect } from "react";
import { Drawer, IconButton, List } from "@material-ui/core";
import MobileUserProfile from './MobileUserProfile/MobileUserProfile';
import './Sidebar.css';

import {
  Wallpaper as WallpaperIcon,
  CloudOutlined as CloudOutlinedIcon,
  ViewHeadlineOutlined as ViewHeadlineOutlinedIcon,
  ViewListOutlined as ViewListOutlinedIcon,
  Home as HomeIcon,
  ArrowBack as ArrowBackIcon,
  Settings as MasterIcon,
  EqualizerOutlined as EqualizerOutlinedIcon,
  AddShoppingCart as AddShoppingCartIcon,
  Report as ReportIcon,
  Functions as FunctionsIcon,
  Timeline as TimelineIcon,
  Apps as AppsIcon,
  AccountBalance as AccountBalanceIcon,
  Work as WorkIcon,
  Subject as SubjectIcon,
  Keyboard as KeyboardIcon,
  NotificationsActive as NotificationsActiveIcon,
  Dns as DnsIcon,
  Person as PersonIcon,
  PersonPin as PersonPinIcon,
  LiveTv as LiveTvIcon,
  MobileScreenShare as MobileScreenShareIcon,
  DesktopMac as DesktopMacIcon,
  RateReview as RateReviewIcon,
  Business as BusinessIcon,
  YouTube as YouTubeIcon,
  EmojiObjects as EmojiObjectsIcon,
  EmojiTransportation as EmojiTransportationIcon,
  Commute as CommuteIcon,
  DriveEta as DriveEtaIcon,
  Wc as WcIcon,
  Accessibility as AccessibilityIcon,
} from "@material-ui/icons";
import { useTheme } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import classNames from "classnames";
import useStyles from "./styles";
import AgricultureIcon from '@mui/icons-material/Agriculture';
import SidebarLink from "./components/SidebarLink/SidebarLinkmain";

import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
} from "../../context/LayoutContext";

const structure = [
  {
    id: 0,
    label: "Dashboard",
    icon: <HomeIcon />,
    link: "/app/dashboard"
  },
  {
    id: 1,
    label: "CRM",
    label_sub: "label_sub",
    icon: <TimelineIcon />,
    children: [
      { label: "All Enquiries", link: "/app/allEnquiries" },
      { label: "Interested Enquiries", link: "/app/Interested" },
      { label: "All Pending Enquiries", link: "/app/pendingEnquiriesAll" },
      { label: "Search User", link: "/app/searchUser" },
      { label: "Bulk Upload", link: "/app/bulkUpload" },
    ],
    children_sub: [
      { label: " children_sub Enquiries", link: "" },

    ],
  },
  {
    id: '2',
    icon: <AppsIcon />,
    label: "Enquiry Management",
    children: [
      {
        id: '10',
        label: 'New',
        link: '/',
        icon: <AgricultureIcon />,
        children: [
          {
            id: '8',
            label: 'Tractor',
            link: '/app/NewTractorEnquiry',
            icon: <FunctionsIcon />,
          },
          {
            id: '8',
            label: 'Tractor Not Interested Enq.',
            link: '/app/NewTractorNotInterestedEnquiries',
            icon: <FunctionsIcon />,
          },
          {
            id: '8',
            label: 'Implement',
            link: '/app/NewImplementEnquiries',
            icon: <FunctionsIcon />,
          },
          {
            id: '8',
            label: 'Harvester',
            link: '/app/NewHarvesterEnquiries',
            icon: <FunctionsIcon />,
          },
          {
            id: '8',
            label: 'Earth Mover',
            link: '/app/NewEarthMover',
            icon: <FunctionsIcon />,
          },
        ],
      },

      {
        id: '6',
        label: 'Shop ',
        icon: <AddShoppingCartIcon />,
        children: [
          {
            id: '8',
            label: 'Order Booking',
            link: '/app/ShopProductEnquiry',
          },
          {
            id: '8',
            label: 'Expert Advice',
            link: '/app/ShopExpertAdviceEnquiry',
            icon: <FunctionsIcon />,
          },
          {
            id: '8',
            label: 'Expert Crop Advice',
            link: '/app/ShopExpertAdviceCropEnquiry',
            icon: <FunctionsIcon />,
          },
        ],
      },
      {
        id: '6',
        label: 'Old ',
        icon: <CommuteIcon />,
        children: [
          {
            id: '8',
            label: 'Tractor Contact Seller',
            link: '/app/OldContactSeller',
          },

        ],
      },
      {
        id: '6',
        label: 'Rent ',
        icon: <EmojiTransportationIcon />,
        children: [
          {
            id: '8',
            label: 'Rent Tractor Enquires',
            link: '/app/RentTractorEnquiry',
          },

        ],
      },
      {
        id: '6',
        label: 'Dealers ',
        icon: <WcIcon />,
        children: [
          {
            id: '8',
            label: 'Dealers',
            link: '/app/Dealers',
          },
          {
            id: '8',
            label: 'Contact Dealers',
            link: '/app/ContactDealerEnquiry',
            icon: <FunctionsIcon />,
          },
          {
            id: '8',
            label: 'Dealership Enquiry',
            link: '/app/DealershipEnquiries',
            icon: <FunctionsIcon />,
          },

        ],
      },

      {
        id: '14',
        label: 'API Response',
        icon: <CloudOutlinedIcon />,
        children: [
          {
            id: '14-1',
            label: 'Escorts Responses',
            link: '/app/EscortAPIResponse',
            icon: <FunctionsIcon />,
          },
          {
            id: '14-2',
            label: 'CNH Responses',
            link: '/app/CNHAPIResponse',
            icon: <FunctionsIcon />,
          },
          {
            id: '14-3',
            label: 'JCB Responses',
            link: '/app/JCBAPIResponse',
            icon: <FunctionsIcon />,
          },
          {
            id: '14-4',
            label: 'Carnot Responses',
            link: '/app/CarnotResponses',
            icon: <FunctionsIcon />,
          },
          {
            id: '14-5',
            label: 'Tafe Responses',
            link: '/app/TafeAPIResponse',
            icon: <FunctionsIcon />,
          },
          {
            id: '14-6',
            label: 'Sonalika Responses',
            link: '/app/SonalikaAPIResponse',
            icon: <FunctionsIcon />,
          },
          {
            id: '14-7',
            label: 'Kubota Responses',
            link: '/app/KubotaAPIResponse',
            icon: <FunctionsIcon />,
          },
          {
            id: '14-8',
            label: 'Eicher Responses',
            link: '/app/EicherAPIResponse',
            icon: <FunctionsIcon />,
          },
          {
            id: '14-9',
            label: 'Massey Responses',
            link: '/app/MasseyFergusonAPIResponse',
            icon: <FunctionsIcon />,
          },
          {
            id: '14-10',
            label: 'finance Responses',
            link: '/app/FinanceEnquiryResponse',
            icon: <FunctionsIcon />,
          },

        ],
      },
      {
        id: '15',
        label: 'Social Media',
        icon: <ViewHeadlineOutlinedIcon />,
        children: [
          {
            id: '15-1',
            label: 'Social Campaigns',
            link: '/app/SocialCampaigns',
            icon: <FunctionsIcon />,
          },
          {
            id: '15-2',
            label: 'Brand Assign to Campaign',
            link: '/app/BrandAssignToCampaign',
            icon: <FunctionsIcon />,
          },
          {
            id: '15-3',
            label: 'Brand Assign to Project',
            link: '/app/BrandAssignToProject',
            icon: <FunctionsIcon />,
          },
          {
            id: '15-4',
            label: 'Organic Leads',
            link: '/app/OrganicLeads',
            icon: <FunctionsIcon />,
          },
          {
            id: '15-5',
            label: 'Brand Target Form',
            link: '/app/BrandTargetForm',
            icon: <FunctionsIcon />,
          },
        
        ],
      },
      {
        id: '16',
        label: 'Allied',
        icon: <ViewListOutlinedIcon />, // or FunctionsIcon
        children: [
          {
            id: '16-1',
            label: 'Tyre',
            link: '/app/TyreEnquiries',
            icon: <FunctionsIcon />,
          },
          {
            id: '16-2',
            label: 'Contact Us',
            link: '/app/ContactUsEnquiries',
            icon: <FunctionsIcon />,
          },
          {
            id: '16-3',
            label: 'Loan',
            link: '/app/Loan',
            icon: <FunctionsIcon />,
          },
          {
            id: '16-4',
            label: 'Allied Clients',
            link: '/app/AlliedClientsEnquiry',
            icon: <FunctionsIcon />,
          },
          {
            id: '16-5',
            label: 'Authorized Dealer Listing Enq.',
            link: '/app/AuthorizedDealer',
            icon: <FunctionsIcon />,
          },
          {
            id: '16-6',
            label: 'JCB Enquiries',
            link: '/app/JCBEnquiries',
            icon: <FunctionsIcon />,
          },
          {
            id: '16-7',
            label: 'Finance Enquiries',
            link: '/app/FinanceEnquiries',
            icon: <FunctionsIcon />,
          },
        ],
      },

    ],
  },

  // #################### eee

  {
    id: 3,
    label: "Ambassador",
    icon: <EqualizerOutlinedIcon />,
    children: [
      { label: "Ambassador Registration", link: "/app/ambassadorregistration" },
      { label: "Ambassador Enquiries", link: "/app/ambassadorsenquiries" },
      { label: "Ambassadors", link: "/app/ambassadors" },
      { label: "KYC Verfication", link: "/app/ambassadorskyc" },
      { label: "Complaints", link: "/app/ambassadorComplaints" },
      { label: "Wallet Transactions", link: "/app/ambassadorWallet" },
      { label: " Withdrawal Request", link: "/app/allwithdrawalrequests" },
      { label: "Ambassadors Schemes", link: "/app/ambassadorSchemes" },
      { label: "Ambassadors Banners", link: "/app/ambassadorBanners" },
    ],
  },
  {
    id: '5',
    icon: <AddShoppingCartIcon />,
    label: "Seller Zone",
    children: [
      {
        id: '10',
        label: 'Dealer',
        link: '/',
        icon: <WcIcon />,
        children: [
          {
            id: '8',
            label: 'Dealer Registration',
            link: '/',
            icon: <FunctionsIcon />,
          },
          {
            id: '8',
            label: 'View Registered Dealers',
            link: '/',
            icon: <FunctionsIcon />,
          },
        ],
      },

      {
        id: '6',
        label: 'Trust seal',
        icon: <AccessibilityIcon />,
        children: [
          {
            id: '8',
            label: 'Plan',
            link: '/',
            icon: <AccessibilityIcon />,
          },
        ],
      },
      {
        id: '11',
        label: 'Subscription plans',
        link: '/',
        icon: <FunctionsIcon />,
      },
      {
        id: '11',
        label: 'Recharge',
        link: '/',
        icon: <FunctionsIcon />,
      },
      {
        id: '11',
        label: 'Paid listing',
        link: '/',
        icon: <FunctionsIcon />,
      },
      {
        id: '11',
        label: 'Bulk Dealership Upload',
        link: '/',
        icon: <FunctionsIcon />,
      },
      {
        id: '11',
        label: 'Business KYC Requests',
        link: '/',
        icon: <FunctionsIcon />,
      },
    ],
  },

  {
    id: 4,
    label: "New",
    icon: <AgricultureIcon />,
    children: [
      { label: "Tractor", link: "/app/newTractors" },
      { label: "Implement", link: "/app/newimplements" },
      { label: "Harvester", link: "/app/newHarvesters" },
      { label: "Tyre", link: "/app/newtyres" },
    ],
  },

  {
    id: 5,
    label: "Old",
    icon: <CommuteIcon />,
    children: [
      { label: "Tractor", link: "/app/oldTractors" },
      { label: "Implement", link: "/app/oldimplements" },
      { label: "Harvester", link: "/app/oldHarvesters" },
      { label: "Commercial Vehicle", link: "/app/commercialvehicles" },

    ],
  },
  {
    id: 6,
    label: "Rent",
    icon: <EmojiTransportationIcon />,
    children: [
      { label: "Tractor", link: "/app/rentTractors" },
      { label: "Implement", link: "/app/rentimplements" },
      { label: "Harvester", link: "/app/rentHarvesters" },

    ],
  },

  {
    id: 7,
    label: "Compare",
    icon: <ReportIcon />,
  },

  {
    id: 8,
    label: "Brands",
    icon: <EmojiObjectsIcon />,
    children: [

      { label: "Add Brands", link: "/app/AddingBrand" },
      { label: "View Brands", link: "/app/AllBrands" },
    ],
  },

  {
    id: 9,
    label: "Video Management",
    icon: <YouTubeIcon />,
    link: "/app/VideoManagement",
  },
  {
    id: 10, label: "FAQ Management",
    link: "",
    icon: <BusinessIcon />
  },
  {
    id: 11, label: "Reviews",
    link: "/app/Reviews",
    icon: <RateReviewIcon />
  },
  {
    id: '11',
    icon: <LiveTvIcon />,
    label: "Advertise",
    children: [
      {
        id: '10',
        icon: <MobileScreenShareIcon />,
        label: 'Mobile App Ads',
        children: [
          {
            id: '8',
            label: 'Display Mobile Banner Ads',
            link: '/',
            icon: <MobileScreenShareIcon />,
          },

        ],
      },
      {
        id: '10',
        label: 'Website Ads',
        link: '/',
        icon: <DesktopMacIcon />,

        children: [
          {
            id: '8',
            label: 'Display Banner Ads',
            link: '/',
            icon: <FunctionsIcon />,
          },
          {
            id: '8',
            label: 'Active Campian Report',
            link: '/',
            icon: <FunctionsIcon />,
          },
          {
            id: '8',
            label: 'Banner Size Ad Report ',
            link: '/',
            icon: <FunctionsIcon />,
          },
          {
            id: '8',
            label: 'Web-Pages Ad Report ',
            link: '/',
            icon: <FunctionsIcon />,
          },
          {
            id: '8',
            label: 'De-active Campian Report ',
            link: '/',
            icon: <FunctionsIcon />,
          },

        ],
      },
    ],
  },
  {
    id: 11, label: "User Roles",
    link: "",
    icon: <PersonPinIcon />,
    children: [

      { label: "All Users", link: "/app/AllUsers" },
      { label: "Users Login", link: "/app/userlogin" },
    ],
  },
  {
    id: 11, label: "Reports",
    link: "",
    icon: <DnsIcon />,
    children: [
      { label: "Monthly Report", link: "/app/monthlyreport" },
      { label: "Not Interested Report", link: "/app/notinterestedreport" },
      { label: "Supplied Report", link: "/app/suppliedreport" },
      { label: "Old Tractor Report", link: "/app/oldtractoreport" },

      { label: "Mech. Calling Stat Report", link: "/app/Mechcallingstatreport" },
      { label: "Tractor Owner Report", link: "/app/TractorOwnerReport" },
      { label: "Interested Attemptwise Report", link: "/app/InterestedAttemptwiseReport" },
      { label: "Not Interested Attemptwise", link: "/app/NotInterestedAttemptwiseReport" },
      { label: "Not Contact Enquiries Report", link: "/app/NotContactEnquiriesReport" },
      { label: "Campaign Month Report", link: "/app/CampaignMonthReport" },
      { label: "Brand Month Report", link: "/app/BrandMonthReport" },
      { label: "Social Media Report", link: "/app/SocialMediaReport" },
      { label: "Move To Bulk Report", link: "/app/MoveToBulkReport" },
      { label: "Duplicate Lead Report", link: "/app/DuplicateLeadReport" },
      { label: "Invalid Number Report", link: "/app/InvalidNumberReport" },
      { label: "Count Report", link: "/app/CountReport" },
      { label: "Day Wise Brand Supply Report", link: "/app/DayWiseBrandSupplyReport" },
      { label: "Brand Wise Target Report", link: "/app/BrandWiseTargetReport" },
      { label: "Target Vs LeadGeneration Report", link: "/app/TargetVsLeadGenerationReport" },
      { label: "Target Vs Lead Supply Report", link: "/app/TargetVsLeadSupplyReport" },
      { label: "John Deere Api Transfer Report", link: "/app/JohnDeereApiTransferReport" },
      { label: "Duplicate Campaign Report", link: "/app/DuplicateCampaignReport" },
      { label: "Monthly Social Count Reports", link: "/app/MonthlySocialCountReports" },
    ],
  },
  {
    id: 11, label: "Blacklist Users",
    link: "",
    icon: <PersonIcon />,
  },
  {
    id: 11, label: "Notification",
    link: "/app/Notifications",
    icon: <NotificationsActiveIcon />,
  },
  {
    id: 11, label: "Keywords",
    link: "/app/Keywords",
    icon: <KeyboardIcon />,
  },
  {
    id: 11, label: "Statistics Reports",
    link: "",
    icon: <SubjectIcon />,
    children: [
      { label: "Tractor Stat Report", link: "/app/TractorStatReport" },
      { label: "Implement Stat Report", link: "/app/ImplementStatReport" },
      { label: "Harvester Stat Report", link: "/app/harvesterStatReport" },
      { label: "Tyre Stat Report", link: "/app/TyreStatReport" },
      { label: "Shop Order Reports", link: "/app/ShopOrderReports" },

    ],
  },
  {
    id: 11, label: "Khetigaadi Career",
    link: "",
    icon: <WorkIcon />,
    children: [
      { label: "Job Openings", link: "/app/JobOpenings" },
      { label: "Applications", link: "/app/applications" },

    ],
  },

];

function Sidebar({ location }) {
  var classes = useStyles();
  var theme = useTheme();
  // global
  var { isSidebarOpened } = useLayoutState();
  var layoutDispatch = useLayoutDispatch();
  // local
  var [isPermanent, setPermanent] = useState(true);
  useEffect(function () {
    window.addEventListener("resize", handleWindowWidthChange);
    handleWindowWidthChange();
    return function cleanup() {
      window.removeEventListener("resize", handleWindowWidthChange);
    };
  });
  const adminAccess =
    JSON.parse(localStorage.getItem("admin_access")) || [];

  const moduleList = adminAccess.map(
    item => item.module?.module?.toLowerCase()
  );
  const isSuper = moduleList.includes("super");
  const isTelecaller = moduleList.includes("telecaller");
  const isAmbassador = moduleList.includes("ambassador");
  const isSellerzone = moduleList.includes("sellerzone");
  const isProductExecutive = moduleList.includes("productExecutive");
  const isAdvertise = moduleList.includes("advertise");
  const isShopKhetiguru = moduleList.includes("shopKhetiguru");
  const isInfraSellerzone = moduleList.includes("infra-sellerzone");
  const isInfra = moduleList.includes("infra");

  const filteredStructure = structure.filter(menu => {
    if (isSuper) return true;

    if (isTelecaller) {
      return ["Dashboard", "CRM"].includes(menu.label);
    }
    if (isAmbassador) {
      return ["Dashboard", "CRM", "Ambassador", "Enquiry Management", 'Reports'].includes(menu.label);
    }
    if (isSellerzone) {
      return ["Dashboard", "Seller Zone"].includes(menu.label);
    }
    if (isProductExecutive) {
      return ["Dashboard", "Enquiry Management", 'Reports'].includes(menu.label);
    }
    if (isAdvertise) {
      return ["Dashboard", "Advertise"].includes(menu.label);
    }
    if (isShopKhetiguru) {
      return ["Dashboard", "CRM"].includes(menu.label);
    }
    if (isInfraSellerzone) {
      return ["Dashboard", "CRM"].includes(menu.label);
    }
    if (isInfra) {
      return ["Dashboard", "CRM"].includes(menu.label);
    }

    return false;
  });


  return (

    <Drawer
      variant={isPermanent ? "permanent" : "temporary"}
      className={classNames(classes.drawer, {
        [classes.drawerOpen]: isSidebarOpened,
        [classes.drawerClose]: !isSidebarOpened,
      })}
      classes={{
        paper: classNames({
          [classes.drawerOpen]: isSidebarOpened,
          [classes.drawerClose]: !isSidebarOpened,
        }),
      }}
      open={isSidebarOpened}
    >
      <div className={classes.toolbar} />
      <div className={classes.mobileBackButton}>
        <IconButton onClick={() => toggleSidebar(layoutDispatch)}>

          <ArrowBackIcon
            style={{ color: "#ffffff" }}
            classes={{
              root: classNames(classes.headerIcon, classes.headerIconCollapse),
            }}
          />
        </IconButton>
      </div>
      <List >

        {/* <List className={classes.sidebarList} >
          {structure.map(link => (
            <SidebarLink
              key={link.id}
              location={location}
              isSidebarOpened={isSidebarOpened}
              {...link}
            />
          ))}
        </List> */}


        <div className="sidebar_profile" style={{ marginTop: "-35px" }}>
          <MobileUserProfile />
          <List className={classes.sidebarList} >
            {master.map(link => (
              <SidebarLink
                key={link.id}
                location={location}
                isSidebarOpened={isSidebarOpened}
                {...link}
              />
            ))}
          </List>
          <hr />
        </div>

        <List className={classes.sidebarList}
          style={{
            paddingLeft: "5px",
            paddingTop: "1px",
            marginTop: "-15px",
            marginLeft: "-25px",
          }} >
          {/* {structure.map(link => ( */}
          {filteredStructure.map(link => (
            <SidebarLink
              key={link.id}
              location={location}
              isSidebarOpened={!isSidebarOpened}
              {...link}
            />
          ))}
        </List>
      </List>
    </Drawer>
  );

  // ##################################################################

  function handleWindowWidthChange() {
    var windowWidth = window.innerWidth;
    var breakpointWidth = theme.breakpoints.values.md;
    var isSmallScreen = windowWidth < breakpointWidth;

    if (isSmallScreen && isPermanent) {
      setPermanent(false);
    } else if (!isSmallScreen && !isPermanent) {
      setPermanent(true);
    }
  }

}

export default withRouter(Sidebar);


const master = [
  {
    id: 1,
    label: "Master Department",
    icon: <MasterIcon />,
    children: [
      { label: " Company Master ", link: "/app/companyMaster", icon: <WallpaperIcon />, },
      { label: " Department Master ", link: "/app/departmentmaster" },
      { label: " Designation Master ", link: "/app/designationMaster" },
      { label: " Employee Master  ", link: "/app/EmployeeMaster" },
      { label: " Cupboard Master ", link: "/app/CupboardMaster" },
      { label: " Expense Master ", link: "/app/expenseMaster" },
      { label: " System Master ", link: "/app/SystemSetting" },
      { label: " Rule Management ", link: "/app/RuleManagement" },
      { label: " Earnings Deductions ", link: "/app/CompanyEarnings" },
    ],
  },
];







